<template>
  <div class="mb-3" v-if="tabs.length > 0">
    <nav class="flex">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :class="['tab', selected === tab.value ? 'tab-active' : '']"
        @click="setTab({ tabKey, tab: tab.value })">
        {{ tab.text}}
      </button>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    },
    tabKey: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      setTab: 'results/setTab'
    })
  }
}
</script>

<style>
.tab {
  @apply text-gray-400 mr-2 hover:bg-gray-300 focus:outline-none text-sm font-bold bg-gray-200 py-2 px-4 text-gray-500
}

.tab-active {
  @apply text-black font-bold text-white bg-black hover:bg-black
}
</style>
